import styled from 'styled-components';
import { rem } from '@/styles/theme';
import { PLACEHOLDER_MIDDLE_BANNER } from '@/const';

const Wrapper = styled.div`
  position: relative;
  aspect-ratio: 342/92;
  border-radius: ${rem(16)};
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  object-fit: cover;
  border-radius: ${rem(16)};
`;

interface IProps {
  src: string;
  alt: string;
  onClick: () => void;
}

const Banner = (props: IProps) => {
  const { src, alt, onClick } = props;

  return (
    <Wrapper onClick={onClick}>
      <Image src={src || PLACEHOLDER_MIDDLE_BANNER} alt={alt} loading="lazy" />
    </Wrapper>
  );
};

export default Banner;
